import * as React from 'react';

import {
  createTheme,
  CssBaseline,
  UnifiThemeProvider,
  ThemeOptions,
} from '@nelnet/unifi-components-react';

const globalLayoutStyles = {
  // strongly recommended
  body: {
    minHeight: '100vh',
  },
  // Optional - demos how to affect the root wrapper
  '#___gatsby': {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
};

const extendedUnifi = {
  themeName: 'Unifi Documentation',
  overrides: {
    MuiCssBaseline: {
      '@global': { ...globalLayoutStyles },
    },
  },
} as ThemeOptions;

// Used by gatsby-browser and gatsby-ssr to correctly apply/update stylesheets
const ThemeProvider: React.FunctionComponent = ({ children }) => {
  const theme = createTheme(extendedUnifi);

  return (
    <UnifiThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      {children}
    </UnifiThemeProvider>
  );
};

export default ThemeProvider;
